module.exports = __webpack_public_path__ + "static/LGLogoImage-357c64fddf69a4cd11f0a9135f8f505b.png";